import React from 'react';
import {MT7_REGISTRATION_CONTEST} from "../../../../../AdminPart/GraphQL/queries/OnlyHereQueries";
import {useMutation} from "@apollo/client";

function MutationContestRegistration (props) {
    // function TextSource(info) {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}
    const [MT7RegistrationContest, { data, loading, error }] = useMutation(MT7_REGISTRATION_CONTEST);
    if (loading) return <p>
        {/*<TextSource ArrIndex= 'ContestRegistrationForm0240'>Идет регистрация конкурсного счета</TextSource>*/}
        Registration is underway...
    </p>;
    if (error) {return (<div>
        <p>Error: ${error.message}</p>;
        <div className='ButtonOut'>
            <div className='Button3D' role = "button" tabIndex={0}
                 onClick={async event => {event.preventDefault();props.updateFunction(event,MT7RegistrationContest({ variables: { email : props.Email, password : props.Password, TradingAccount : props.TradingAccount, ContestName: props.ContestName } }));}}
            >
                {/*<TextSource ArrIndex= 'ContestRegistrationForm0245'>Принять участие в конкурсе</TextSource>*/}
                Take part in the competition
            </div>
        </div></div>);
    }
    return (
                        <div className='ButtonOut'>
                            <div className='Button3D' role = "button" tabIndex={0}
                                 onClick={async event => {event.preventDefault();props.updateFunction(event,MT7RegistrationContest({ variables: { email : props.Email, password : props.Password, TradingAccount : props.TradingAccount, ContestName: props.ContestName } }));}}
                            >
                                {/*<TextSource ArrIndex= 'ContestRegistrationForm0250'>Принять участие в конкурсе</TextSource>*/}
                                Take part in the competition
                            </div>
                        </div>
    )}
export default MutationContestRegistration